import { createFileRoute } from "@tanstack/react-router";
import { ProblemsScreen, type ProblemsSearch, type ProblemsTab } from "../screens/staff/ProblemsScreen.tsx";

/** `/sysadmin/problems`: failed runs, failed jobs and billing events. */
const TABS: ProblemsTab[] = ["jobs", "billing"];

export const Route = createFileRoute("/_staff/sysadmin/problems")({
  validateSearch: (search: Record<string, unknown>): ProblemsSearch => ({
    ...(TABS.includes(search.tab as ProblemsTab) ? { tab: search.tab as ProblemsTab } : {}),
    ...(Number(search.days) === 30 ? { days: 30 as const } : {}),
  }),
  component: ProblemsScreen,
});
